import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function logoutReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return Map({
        loading: true,
        error: null,
      });
    case actionTypes.SUCCESS:
      return Map({
        loading: false,
        error: null,
      });
    case actionTypes.FAILURE:
      return Map({
        loading: false,
        error: action.payload,
      });
    default:
      return state;
  }
}
